/**
 * 通用桥包装类
 * http://wiki.vipkid.com.cn/pages/viewpage.action?pageId=235289299
 */
const Bridge = class {
  constructor($config, $ctx) {
    this.$config = $config;
    this.$ctx = $ctx;

    // 根据环境加载桥SDK
    this.instance = null;

    // 监听器集合
    this.listeners = null;
  }

  /**
   * 统一调用桥方法
   */
  async call({
    name,
    params,
    timeout = 1e4,
    version,
  }) {
    if (this.instance === null) {
      const BridgeModule = await this.loadInstance();
      if (BridgeModule) {
        this.instance = new BridgeModule(this.$config, this.$ctx);
      }
    }

    if (this.instance) {
      return this.instance.request({
        name,
        params,
        timeout,
        version,
      }).then(response => {
        if (!this.$ctx.isProd()) console.log(`$bridge:resolve:${name}`, response);
        return response;
      });
    }

    const startTime = new Date().getTime();
    return {
      errorCode: 'UNDEFINE',
      name,
      params,
      timeout,
      startTime,
      endTime: startTime,
    };
  }

  /**
   * 监听Native消息
   * name格式：module/method
   */
  async addEventListener(name, callback) {
    if (this.listeners === null) {
      this.listeners = {};
      await this.call({
        name: '__bridge_ready__',
        version: 3,
      });

      if (this.instance) {
        this.instance.nativeCallWeb = (response) => {
          const callbackList = this.listeners[`${response?.module}/${response?.method}`];
          if (callbackList && callbackList.length) {
            callbackList.forEach(cb => cb(response));
          }
        };
      }
    }

    if (!(name in this.listeners)) {
      this.listeners[name] = [];
    }
    this.listeners[name].push(callback);
  }

  /**
   * 根据环境加载相应的桥接口
   */
  async loadInstance() {
    switch (this.$ctx.appInfo?.platform) {
      case 'ios':
      case 'ipad':
      case 'iphone':
        return import(
          /* webpackChunkName: "bridge-vkapp-ios" */
          './libs/bridge-vkapp-ios'
        ).then(chunk => chunk.default);
      case 'android':
      case 'aphone':
      case 'apad':
        return import(
          /* webpackChunkName: "bridge-vkapp-android" */
          './libs/bridge-vkapp-android'
        ).then(chunk => chunk.default);
      case 'windows':
      case 'mac':
        return import(
          /* webpackChunkName: "bridge-vkpc-student" */
          './libs/bridge-vkpc-student'
        ).then(chunk => chunk.default);
      default:
        return 0;
    }
  }
};

export default Bridge;
